import { merge } from '@/helpers/Utility';
import { FC, HTMLAttributes } from 'react';
import { RosterBusyPickerHeight } from './DateRadioPickerDay';
import { DateRadioPickerOptionColor } from './dateRadioPicker.types';

interface DateRadioPickerButtonProps extends HTMLAttributes<HTMLDivElement> {
  isActive: boolean;
  onSelect: () => void;
  optionColor?: DateRadioPickerOptionColor;
}

export const DateRadioPickerButton: FC<DateRadioPickerButtonProps> = ({ isActive, onSelect, className, optionColor }) => {
  let bgStyle = '';
  let inputStyle = '';

  if (isActive) {
    switch (optionColor) {
      case DateRadioPickerOptionColor.GREEN:
        bgStyle = 'bg-green-100';
        inputStyle = 'text-green-500 focus:ring-green-500';
        break;
      case DateRadioPickerOptionColor.YELLOW:
        bgStyle = 'bg-yellow-100';
        inputStyle = 'text-yellow-500 focus:ring-yellow-500';
        break;
      case DateRadioPickerOptionColor.RED:
        bgStyle = 'bg-red-100';
        inputStyle = 'text-red-500 focus:ring-red-500';
        break;
    }
  }

  return (
    <div className={merge(`flex items-center justify-center`, bgStyle, className, RosterBusyPickerHeight)}>
      <input className={merge(`rounded-md w-5 h-5`, inputStyle)} type="radio" onClick={onSelect} checked={isActive} />
    </div>
  );
};
